import React, { useEffect, useState } from "react";
import { Box, CardContent, CircularProgress, Alert, Typography } from "@mui/material";
// import LightbulbRoundedIcon from "@mui/icons-material/LightbulbRounded";
import GlassCard from "../Cards/GlassCard";
import axiosInstance from "../../services/axiosInstance";
// import { WARNING } from "../../utils/colors";

const LeetCodeBatchInsightsSection = ({ batchId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [insights, setInsights] = useState([]);

  useEffect(() => {
    if (!batchId) return;
    let active = true;
    setLoading(true);
    setError("");

    axiosInstance
      .get("/analytics/leetcode/insights", { params: { batchId } })
      .then(({ data }) => {
        if (!active) return;
        setInsights(Array.isArray(data?.insights) ? data.insights : []);
      })
      .catch((err) => {
        if (!active) return;
        setInsights([]);
        setError(err?.response?.data?.message || "Failed to load automated insights.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [batchId]);

  return (
    <GlassCard hoverable={false} sx={{ borderRadius: 3, mt: 2 }}>
      <CardContent sx={{ p: 2.5 }}>
        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <LightbulbRoundedIcon sx={{ color: WARNING }} />
          <Typography variant="subtitle1" fontWeight={700}>
            Automated Batch Insights
          </Typography>
        </Box> */}

        {loading && (
          <Box sx={{ py: 2, display: "flex", justifyContent: "center" }}>
            <CircularProgress size={26} />
          </Box>
        )}

        {!loading && error && (
          <Alert severity="error" sx={{ borderRadius: 2 }}>
            {error}
          </Alert>
        )}

        {!loading && !error && insights.length === 0 && (
          <Alert severity="info" sx={{ borderRadius: 2 }}>
            No insights available for this batch yet.
          </Alert>
        )}

        {!loading && !error && insights.length > 0 && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {insights.map((text, idx) => (
              <Box
                key={`${idx}-${text.slice(0, 20)}`}
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  px: 1.5,
                  py: 1,
                }}
              >
                <Typography variant="body2">
                  {idx + 1}. {text}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </GlassCard>
  );
};

export default LeetCodeBatchInsightsSection;
